"use strict";
module.exports = BufferWriter;

/*             */
var Writer = require("./writer");
(BufferWriter.prototype = Object.create(Writer.prototype)).constructor = BufferWriter;

var util = require("./util/minimal");

/**
 *
 *
 *
 *
 */
function BufferWriter() {
    Writer.call(this);
}

BufferWriter._configure = function () {
    /**
 *
 *
 *
 *
 */
    BufferWriter.alloc = util._Buffer_allocUnsafe;

    BufferWriter.writeBytesBuffer = util.Buffer && util.Buffer.prototype instanceof Uint8Array && util.Buffer.prototype.set.name === "set"
        ? function writeBytesBuffer_set(val, buf, pos) {
          buf.set(val, pos); /*                                                                                                  */
          /*                                */
        }
        /*                      */
        : function writeBytesBuffer_copy(val, buf, pos) {
          if (val.copy) /*            */
            val.copy(buf, pos, 0, val.length);
          else for (var i = 0; i < val.length;) /*                 */
            buf[pos++] = val[i++];
        };
};


/**
 *
 */
BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if (util.isString(value))
        value = util._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len)
        this._push(BufferWriter.writeBytesBuffer, len, value);
    return this;
};

function writeStringBuffer(val, buf, pos) {
    if (val.length < 40) /*                                                                          */
        util.utf8.write(val, buf, pos);
    else if (buf.utf8Write)
        buf.utf8Write(val, pos);
    else
        buf.write(val, pos);
}

/**
 *
 */
BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = util.Buffer.byteLength(value);
    this.uint32(len);
    if (len)
        this._push(writeStringBuffer, len, value);
    return this;
};


/**
 *
 *
 *
 *
 */

BufferWriter._configure();
